import React from "react";

type Props = {
  icon: React.ReactNode;
  code: string;
  title: string;
  description: string;
  children?: React.ReactNode;
};

const ErrorState = ({ icon, code, title, description, children }: Props) => (
  <div className="flex flex-col items-center justify-center px-4 py-10 text-center md:py-14">
    <div className="mx-auto mb-3 flex h-12 w-12 items-center justify-center rounded-full bg-[#34699A]/10 text-[#113F67]">
      {icon}
    </div>

    <h2 className="text-xl font-semibold text-[#113F67] md:text-2xl">{title}</h2>

    <p className="mt-2 max-w-xl text-sm text-gray-500 md:text-base">
      {description}
    </p>

    <div className="mt-4 text-5xl font-bold tracking-tight text-[#113F67]">
      {code}
    </div>

    {children && (
      <div className="mt-6 flex w-full flex-col gap-3 sm:w-auto sm:flex-row">
        {children}
      </div>
    )}
  </div>
);

export default ErrorState;
